import React, { useState } from 'react'
import Side from "../../components/sidebar/Side.jsx"
import "./formulario.scss";
import Swal from 'sweetalert2';
import { addDoc, collection, getDocs, query, serverTimestamp, where } from "firebase/firestore";
import { db } from '../../firebase-config.js';
import { useNavigate } from 'react-router-dom';


export function New() {

  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [EventDate, setEventDate] = useState();
  const [OrganizerName, setOrganizerName] = useState("");
  const [StartTime, setStartTime] = useState();
  const [EndTime, setEndTime] = useState();
  const [DeadLineToReserve, setDeadLineToReserve] = useState();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const eventName = Name.replace(/ /g, '-').toLowerCase();
    // Validar si ya existe un evento con el mismo nombre

    // Get event by name
    const eventQuery = query(collection(db, "events"),
      where("name", ">=", eventName)
      , where("name", "<=", eventName));

    const eventData = await getDocs(eventQuery);
    let eventList = [];
    eventData.docs.forEach((doc) => {
      eventList.push({ id: doc.id, ...doc.data() });
    });

    if(eventList.length > 0){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Ya existe un evento con el mismo nombre',
        showConfirmButton: false,
        timer: 1600
      })
      return;
    }

    try {

      if (Name === '') {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'El campo Nombre es obligatorio',
          showConfirmButton: false,
          timer: 1600
        })
        return;
      }

      if (Description === '') {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'El campo Descripción es obligatorio',
          showConfirmButton: false,
          timer: 1600
        })
        return;
      }

      if (EventDate == null) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Debe añadir la fecha de inicio',
          showConfirmButton: false,
          timer: 1600
        })
        return;
      }

      if (DeadLineToReserve == null) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Debe añadir la fecha de reserva',
          showConfirmButton: false,
          timer: 1600
        })
        return;
      }
      const res = await addDoc(collection(db, "events"), {
        name: eventName,
        description: Description,
        eventDate: EventDate,
        organizerName: OrganizerName,
        startTime: StartTime,
        endTime: EndTime,
        deadLineToReserve: DeadLineToReserve,
        timeStamp: serverTimestamp()
      });

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Se ha creado el evento correctamente',
        showConfirmButton: false,
        timer: 1500
      })

      setTimeout(() => {
        navigate('/admin');
      }, 1600);

    } catch {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Oops! Hubo un problema',
        showConfirmButton: false,
        timer: 1600
      })
    };

  }

  return (
    <div className='home'>
      <Side />
      <form className="homeContainer1" >
        <div className='caja'>

          <div className="widgets">
            <label htmlFor='nombre'>Nombre del Evento</label>
            <input type="text" name='Name' className='formulario' placeholder='Nombre...' onChange={(e) => setName(e.target.value)} />
          </div>

          <div className="widgets">
            <label htmlFor='name'>Nombre del Organizador</label>
            <input type="text" name='OrganizerName' className='formulario' placeholder='Nombre y apellido' onChange={(e) => setOrganizerName(e.target.value)} />
          </div>

          <div className="widgets">
            <label>Descripción del Evento</label>
            <textarea rows="5" cols="30" name="Description" className='form2' placeholder='Descripción' onChange={(e) => setDescription(e.target.value)} />
          </div>

          <div className="widgets">
            <label>Fecha de Inicio</label>
            <input type="date" className="formulario" name="EventDate" onChange={(e) => setEventDate(e.target.value)} />
          </div>

          <div className="widgets">
            <label>Fecha limite para reservar</label>
            <input type="date" className="formulario" name="DeadLineToReserve" onChange={(e) => setDeadLineToReserve(e.target.value)} />
          </div>

          <div className="widgets">
            <label>Hora de Inicio</label>
            <input type="time" className="formulario" name="StartTime" onChange={(e) => setStartTime(e.target.value)} />
          </div>

          <div className="widgets">
            <label>Hora de Fin</label>
            <input type="time" className="formulario" name="EndTime" onChange={(e) => setEndTime(e.target.value)} />
          </div>
        </div>
        <div>

          <button type="button" onClick={(e) => handleSubmit(e)}>Crear Evento</button>
        </div>
      </form>
    </div>


  )
}

export default New;